/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import {
  getFilterAllRequisitions,
  getRequisitionObservationsById
} from "../../actions/requisition-actions";
import { getMaestras } from "../../actions/maestras-actions";
import DetailedAccordion from "../../componentes/detailedAccordion.js/DetailedAccordion";
import RequisitionSearch from "./requisitionSearch";
import Search from "../../images/icons/search.svg";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import {
  Typography,
} from "@material-ui/core";

import Utils from "../../utils/utils";
import { permissionsConstans } from "../../constansPermissions";
import RequisitionObservationModal from "./requisitionObservationModal";
import { ERROR_MESSAGE } from "../../constants";

//VER REQUISICIONES

const RequisitionsView = (props) => {
  const [{ filterRequisition, breadCrumb }, dispatch] = useStateValue();
  const [permissionsRequisition, setPermissionsRequisition] = useState([]);
  const [maestras, setMaestras] = useState({
    motivoCierreVacante: [],
    tipoContrato: [],
  });


  const [filter, setFilter] = useState({
    initDate: null,
    endDate: null,
    regional: null,
    requestUser: null,
    chargeRequested: null,
    requisitionNumber: null,
    status: null,
    creationUser: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "requisitionNumber",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });
  const [openObservationsModal, setOpenObservationsModal] = useState(false);
  const [observations, setObservations] = useState([]);

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const { path } = useRouteMatch();

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response.data.maestras);
    };
    getListaMaestras();
  }, []);

  const getReqs = async () => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;
    const FilterEndDate = filter.endDate ? filter.endDate.toISOString().split("T")[0] : null
    const response = await getFilterAllRequisitions(
      {
        initDate: initDate,
        endDate: FilterEndDate,
        regional: filter.regional === "" ? null : filter.regional,
        status: filter.status === "" ? null : filter.status,
        requestUser: filter.requestUser === "" ? null : filter.requestUser,
        chargeRequested:
          filter.chargeRequested === "" ? null : filter.chargeRequested,
        requisitionNumber:
          filter.requisitionNumber === 0 || filter.requisitionNumber === ""
            ? null
            : parseInt(filter.requisitionNumber),
        creationUser: null,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response?.data?.requisitionResponsePage) {
      const data = response.data.requisitionResponsePage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    const responsePersmissions = Utils.validationPermissions("REQ_VIEWER");
    setPermissionsRequisition(responsePersmissions);
    getReqs();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Ver Requisiciones",
      breadCrumbSubText: "Ver Requisiciones",
      index: 144,
    });
  }, [paginadorRequest]);

  if (
    filterRequisition &&
    filterRequisition?.isFilter &&
    filter !== filterRequisition.filter
  ) {
    var newfilter = filterRequisition.filter;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.regional = newfilter.regional;
    filter.requestUser = newfilter.requestUser;
    filter.chargeRequested = newfilter.chargeRequested;
    filter.requisitionNumber = newfilter.requisitionNumber;
    filter.status = newfilter.status;
    filter.creationUser = newfilter.creationUser;
    paginadorRequest.page = 0;
    getReqs();
    dispatch({
      type: "SET_FILTER",
      isFilter: false,
    });
  }

  const verRequisicion = (id) => {
    props.history.push(`${path}/detalle/${id}`);
  };

  const validationPermissionSearch = () => {
    if (
      permissionsRequisition?.functionalities?.some(
        (x) => x === permissionsConstans.REQ_VIEWER_CONSULTAR
      )
    ) {
      return <RequisitionSearch origin="manage" />;
    }
  };

  const onClose = () => {
    setOpenObservationsModal(false);
  };

  const showObservation = async (id) => {
    const response = await getRequisitionObservationsById(id, dispatch);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {

      if (response?.data?.requisitionTraceResponseList) {
        setObservations(response?.data?.requisitionTraceResponseList)
      } else {
        setObservations([]);
      }
      setOpenObservationsModal(true);
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: response?.data?.detail
            ? response?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  }

  return (
    <div style={{ marginTop: "25px" }}>
      {validationPermissionSearch()}
      {paginadorResponse.data.map((row, index) => (
        <DetailedAccordion
          headers={headers}
          data={row}
          onView={verRequisicion}
          maestras={maestras}
          permissionsRequisition={permissionsRequisition}
          permissionsConstans={permissionsConstans}
          onShowObservation={showObservation}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
      {openObservationsModal &&
        <RequisitionObservationModal
          handleClose={onClose}
          open={openObservationsModal}
          observations={observations}
        />}
    </div>
  );
};

export default withRouter(RequisitionsView);
